import { forwardRef } from 'react';
import { useTranslations } from 'next-intl';
import { Loader } from '@/components/base/Layout/Loader';
import styles from './AddressDropdown.module.css';

export const AddressDropdown = forwardRef(
  ({ className = '', items, loading, onSelect, dataTestid }, ref) => {
    const t = useTranslations();
    return (
      <div
        className={`${styles.location_dropdown} ${className}`}
        ref={ref}
        data-testid={dataTestid}
      >
        <ul role="listbox">
          {!loading &&
            items?.length > 0 &&
            items.map((addr) => (
              <li
                key={addr}
                className={`${styles.location_row}`}
                onClick={() => onSelect(addr)}
                role="option"
              >
                <div className={styles.content}>
                  <p title={addr}>{addr}</p>
                </div>
              </li>
            ))}
          {!loading && items?.length === 0 && (
            <li role="option" className={`${styles.location_row}`}>
              <p>{t('form.input.address.empty')}</p>
            </li>
          )}
          {loading && (
            <li role="option">
              <Loader />
            </li>
          )}
        </ul>
      </div>
    );
  },
);
AddressDropdown.displayName = 'AddressDropdown';
